<template>
  <ValidationObserver>
    <div class="row">
      <div class="form-group col-md-10">
        <label>{{$t('street')}}</label>
        <ValidationProvider name="address" v-slot="{ errors }" rules="required">
          <input class="form-control" v-model="address.street" :class="{ 'is-invalid': errors[0] }">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <div class="form-group col-md-2">
        <label>{{$t('number')}}</label>
        <ValidationProvider name="house number" v-slot="{ errors }" rules="required">
          <input class="form-control" v-model="address.houseNumber" :class="{ 'is-invalid': errors[0] }">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-4">
        <label>{{$t('post')}}</label>
        <ValidationProvider name="postal code" v-slot="{ errors }" rules="required">
          <input class="form-control" v-model="address.postalCode" :class="{ 'is-invalid': errors[0] }">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <div class="form-group col-md-8">
        <label>{{$t('city')}}</label>
        <ValidationProvider name="city" v-slot="{ errors }" rules="required">
          <input class="form-control" v-model="address.city" :class="{ 'is-invalid': errors[0] }">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="form-group">
      <label>{{$t('country')}}</label>
      <ValidationProvider name="country" v-slot="{ errors }" rules="required">
        <select class="form-control" v-model="address.country" :class="{ 'is-invalid': errors[0] }">
          <option disabled value=""></option>
          <option v-for="country in countries" v-bind:value="country.code">{{country.name}}</option>
        </select>
        <span class="text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
const countryList = require('country-list');

export default {
  name: 'Address',
  props: ['address'],
  data: () => ({
    countries: countryList.getData(),
  })
}
</script>

<i18n>
{
  "en": {
    "street": "Street Address",
    "number": "House Number",
    "post": "Postal Code",
    "city": "City",
    "country": "Country"
  },
  "sl": {
    "street": "Ulica",
    "number": "Hišna številka",
    "post": "Poštna številka",
    "city": "Mesto",
    "country": "Država"
  }
}
</i18n>
